import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import UserDetailContainer from './../Containers/UserDetailContainer';


function mapStateToProps(state) {
  return { auth: state.auth };
};


class UserRouter extends Component {

	
	render() {
		return(
				<Switch>

					{(!this.props.auth ? <Redirect to="/login" /> : "")}
						<Route exact path='/users/:userid/edit' component={UserDetailContainer} />
						<Route exact path='/users/:userid/personal' component={UserDetailContainer} />
						<Route exact path='/users/:userid/security' component={UserDetailContainer} />
						<Route exact path='/users/:userid/history' component={UserDetailContainer} />
				</Switch>


			
		)
	}
}

export default connect(mapStateToProps)(UserRouter)